import Api from '../api';
import { ensureOk } from '../ensure_ok';
import { CompanyAction } from '../monitoring_companies';

export const applyCompanyAction = (
  action: CompanyAction,
  biddingId: number,
  companyId: number,
  userId: number,
) => {
  if (action === 'archive') {
    return Api.patch('/facilitadores/electronics_trading/archive', {
      bidding_id: biddingId,
      companyId,
      ContactClienteId: userId,
    }).then(ensureOk);
  }
  if (action === 'important') {
    return Api.patch(`/facilitadores/electronics_trading/${biddingId}/toggle_important`, {
      companyId,
    }).then(ensureOk);
  }

  return Api.delete(`/facilitadores/monitoramento/${biddingId}`, { params: { companyId } }).then(
    ensureOk,
  );
};
